import Moment from "moment"
import formatDate from "./date"

export default function formatDateHumanize(date:Moment, format?: string) {

    if (!date) return ''

    const today = Moment();
    if (today.isSame(date, 'day')) return "Today"

    const yesterday = Moment().subtract(1,"days")
    if (yesterday.isSame(date, 'day')) return "Yesterday"

    const tomorrow = Moment().add(1,"days")
    if (tomorrow.isSame(date, 'day')) return "Tomorrow"

    return formatDate(date, format)
}